import * as React from 'react';
import Grid from '@mui/material/Grid';
import { Box, Typography, styled } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import CustomModal from '../Common/CustomModal';
import StyledBackButton from '../Common/StyledBackButton';
import DeleteLoadingButton from '../Common/LoadingButton';

interface IDeleteNoteConfirmationProps {
  handleDelete: () => void;
  handleDismiss: () => void;
  name: string;
  deleteLoading?: boolean;
  deleteModalOpen: boolean;
  isRecording?: boolean;
}

const DeleteButton = styled(LoadingButton)(() => ({
  borderRadius: 15,
  background: `linear-gradient(175.46deg, #FF9A9A -9.81%, #FF5858 96.32%)`,
  color: 'var(--Accent-White, #FFF) !important',
  '&:hover': {
    background: `linear-gradient(175.46deg, #FF9A9A -9.81%, #FF5858 96.32%)`,
  },
}));

const DeleteNoteConfirmation = ({
  handleDelete,
  handleDismiss,
  name,
  deleteLoading,
  deleteModalOpen,
  isRecording = false,
}: IDeleteNoteConfirmationProps) => {
  const { t } = useTranslation();

  return (
    <CustomModal isOpen={deleteModalOpen} width={391}>
      <Grid container maxHeight={401}>
        <Grid
          item
          maxHeight={167}
          textAlign="center"
          sx={{
            background: `linear-gradient(175.46deg, rgba(255, 154, 154, 0.2) -9.81%, rgba(255, 88, 88, 0.2) 96.32%),
                            linear-gradient(0deg, #FFFFFF, #FFFFFF)`,
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
          }}
          width="100%"
          display="flex"
          flexDirection="column"
          gap="11px"
          px={0}
          py={4}
        >
          <Box component="img" height={32} src="/assets/icons/trash-bin-red.svg" />
          <Typography variant="title2Bold" color="#FF5858">
            {t('notes.deleteNoteConfirmation.title')}
          </Typography>
        </Grid>
        <Grid item maxHeight={234} p={4} pt="48px">
          <Typography color="primary.main" textAlign="center">
            {isRecording
              ? t('notes.deleteNoteConfirmation.content3')
              : t('notes.deleteNoteConfirmation.content1')}

            <span style={{ fontWeight: '700' }}>{name}</span>
            {isRecording
              ? t('notes.deleteNoteConfirmation.content4')
              : t('notes.deleteNoteConfirmation.content2')}
          </Typography>
          <Grid container justifyContent="space-between" pt="48px">
            <StyledBackButton disabled={deleteLoading} onClick={handleDismiss}>
              {t('common.dismiss')}
            </StyledBackButton>
            {deleteLoading ? (
              <DeleteLoadingButton>{t('common.confirm')}</DeleteLoadingButton>
            ) : (
              <DeleteButton onClick={handleDelete}>{t('common.confirm')}</DeleteButton>
            )}
          </Grid>
        </Grid>
      </Grid>
    </CustomModal>
  );
};

export default DeleteNoteConfirmation;
